module.exports = __webpack_public_path__ + "static/media/image-3.d3949366.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/ConsumerBehaviour/image-3.png
// module id = 448
// module chunks = 0